import { Injectable } from '@angular/core';
import * as d3 from 'd3';

import { D3ChartSvgg, YAxisData } from '@shared/types/common-graph.types';

import { ChartGridConfig } from '../chart.view-model';

@Injectable()
export class GridService {
  private readonly zeroBaselineStrokeWidth = 1;

  public createGrid(linesContainer: D3ChartSvgg, availableChartsAreaWidth: number, yScale: YAxisData, config?: ChartGridConfig): void {
    const yAxisData = yScale;

    const yAxisGrid = d3
      .axisLeft(yAxisData.scale)
      .tickSize(-availableChartsAreaWidth)
      .tickFormat(() => '');

    if (yScale.tickValues) {
      yAxisGrid.tickValues(yScale.tickValues);
    }

    linesContainer.append('g').attr('class', 'text-foreground-primary-12').call(yAxisGrid);

    linesContainer.selectAll('.domain').remove();
    linesContainer.selectAll('line').attr('stroke-dasharray', '4');

    if (config?.zeroBaseline && yAxisData.scale.domain()[0] <= 0 && yAxisData.scale.domain()[1] >= 0) {
      const zeroYPoint = yAxisData.scale(0);

      linesContainer
        .append('line')
        .attr('x1', 0)
        .attr('x2', availableChartsAreaWidth)
        .attr('y1', zeroYPoint)
        .attr('y2', zeroYPoint)
        .attr('class', 'chart-zero-baseline stroke-foreground-primary-100')
        .attr('stroke-width', this.zeroBaselineStrokeWidth);
    }
  }
}
